
<div class="page-overlay" *ngIf="isBusy" style="height: 100%;">
  <div class="center">
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>
<div class="section-details"> 
    <p>
      <button mat-icon-button *ngIf="isReadonly" color="accent" (click)="startEdit()">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button *ngIf="!isReadonly" color="accent" (click)="discardChanges()">
        <mat-icon>clear</mat-icon>
      </button>
      <button mat-icon-button *ngIf="!isReadonly" [disabled]="!projectForm.isValid" color="accent" (click)="saveChanges()">
        <mat-icon>done</mat-icon>
      </button>
    </p>
    <app-cs-project-form #projectForm [csProject]="csProject" [isReadonly]="isReadonly"></app-cs-project-form>
</div>
<mat-error *ngIf="error">{{error}}</mat-error>

